// Chart 6: 은퇴 후 월 현금흐름 구성 — port of make_cashflow_stack()
import usePlotly from './usePlotly';
import { toManwon } from '../../lib/format';

export default function CashflowStackChart({ npsMonthly, portfolioMonthly, targetMonthly }) {
  const ref = usePlotly(() => ({
    data: [
      {
        type: 'bar',
        name: '국민연금',
        x: ['월 수익'],
        y: [toManwon(npsMonthly)],
        marker: { color: '#7a451f' },
      },
      {
        type: 'bar',
        name: '포트폴리오(세후)',
        x: ['월 수익'],
        y: [toManwon(portfolioMonthly)],
        marker: { color: '#9a6338' },
      },
      {
        type: 'scatter',
        mode: 'markers',
        name: '희망 월 수익(목표)',
        x: ['월 수익'],
        y: [toManwon(targetMonthly)],
        marker: { color: '#c8874a', size: 14, symbol: 'diamond' },
      },
    ],
    layout: {
      barmode: 'stack',
      title: { text: '은퇴 후 월 현금흐름 구성', font: { size: 13 } },
      height: 380,
      yaxis: { title: '만원 / 월', ticksuffix: '만', tickformat: '.0f', gridcolor: '#ead9c7' },
      xaxis: { gridcolor: '#ead9c7' },
    },
  }), [npsMonthly, portfolioMonthly, targetMonthly]);

  return <div ref={ref} style={{ width: '100%' }} />;
}
